import { Component, OnInit, Input, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { PhotoModelComingFrom,
   InspectionObservationPointsViewModel,
    ObservationQuestionsViewModel,
     ObservationPointQuestionImagesViewModel,
      InspectedImplementsViewModel,
       ImplementInspectionImageViewModel,
        InspectImplementQuestionViewModel,
        GeneralQuestionImageViewModel,
        PreInspectionChecklistVM,
        CheckListImagesVM,
   } from '../../../../inspection.model';
import { NewInspectionService } from '../../../../inpsection.service';
import { LoadingService } from '../../../../../../../shared/services/loading.service';
import { NotificationsService } from 'angular2-notifications';
import { FECRPrePostAdditionalObsVM } from '../../../../../../GET_NEW_UI/FECR/FECRDashboard/fecr-search-panel/fecr-search-panel.model';
import { heicTo } from 'heic-to';

@Component({
  selector: 'photos-modal',
  templateUrl: './photos-modal.component.html',
  styleUrls: ['./photos-modal.component.scss']
})
export class PhotosModalComponent implements OnInit {

  @Input()
  observationPoint: InspectionObservationPointsViewModel;

  @Input()
  comingFrom: PhotoModelComingFrom;

  @Input()
  ObservationPointId: number;

  @Output()
  onPhotoUpload: EventEmitter<any> = new EventEmitter();

  @Input()
  implementInspection: InspectedImplementsViewModel;

  @Input()
  question: ObservationQuestionsViewModel;

  @Input()
  inspectionGeneralQuestion: InspectImplementQuestionViewModel;


  @Input()
  preChecklist: PreInspectionChecklistVM;

  @Input()
  ChecklistId: number;


  @Input()
  FECRAdditionalObs: FECRPrePostAdditionalObsVM;

  @Input()
  FECRObsInspectionId: number;

  photo = '';
  photoLoading = false;

  constructor(
    private _inspectionService: NewInspectionService,
    public toastr: NotificationsService, 
    private vcr: ViewContainerRef,
    private _loading: LoadingService) { }

  ngOnInit() {
  }

  async onSelectPhoto(event: any) {

  if (!(event.target.files && event.target.files[0])) {
    return;
  }

  this.photoLoading = true;

  const file = event.target.files[0];

  const extension = file.name.split('.').pop()?.toLowerCase();
  const mimeType = (file.type || '').toLowerCase();

  const isHeic =
    extension === 'heic' ||
    extension === 'heif' ||
    mimeType.includes('heic') ||
    mimeType.includes('heif');

  const processFile = (f: File) => {

    const reader = new FileReader();

    reader.onload = (e: any) => {

      const imageUrl = e.target.result;

      this.compressImage(imageUrl, 643, 540)
        .then((res: string) => {

          if (res) {
            this.uploadPhoto(res.split(',')[1]);
          }

        })
        .catch((err) => {

          this.photoLoading = false;
          console.error(err);

        });

    };

    reader.readAsDataURL(f);
  };

  try {

    if (isHeic) {

      console.log("HEIC detected");

      const convertedBlob = await heicTo({
        blob: file,
        type: "image/jpeg",   // If your version requires, change to "toType"
        quality: 0.8
      });

      const convertedFile = new File(
        [convertedBlob as Blob],
        "converted.jpg",
        {
          type: "image/jpeg"
        }
      );

      processFile(convertedFile);

    } else {

      processFile(file);

    }

  } catch (err: any) {

    this.photoLoading = false;

    console.error("HEIC conversion failed", err);

    this.toastr.error("Failed to upload photo");

  }

  event.target.value = null;
}

  // onSelectPhoto(event: any) {
  //   if (event.target.files && event.target.files[0]) {
  //     this.photoLoading = true;
  //     let file = event.target.files[0];
  //     const isHeic = file.type === "image/heic" || file.name.toLowerCase().endsWith(".heic");
  //     const processFile = (f: File) => {
  //       const reader = new FileReader();
  //       reader.readAsDataURL(f);
  //       reader.onload = (e: any) => {
  //         const imageUrl = e.target.result;
  //         this.compressImage(imageUrl, 643, 540).then((res: string) => {
  //           if (res) {
  //             this.uploadPhoto(res.split(',')[1]);
  //           }
  //         });
  //       };
  //     };
  //     if (isHeic) {
  //       (heic2any as any).default({
  //         blob: file,
  //         toType: "image/jpeg",
  //         quality: 0.8
  //       })
  //       .then((result: any) => {
  //         const convertedBlob = Array.isArray(result) ? result[0] : result;
  //         const convertedFile = new File([convertedBlob], "converted.jpg", {
  //           type: "image/jpeg"
  //         });
  //         processFile(convertedFile);
  //       })
  //       .catch((err: any) => {
  //         console.error("HEIC conversion failed", err);
  //         this.toastr.error('Failed to upload photo');
  //       });
  //     } else {
  //       processFile(file);
  //     }
  //     event.target.value = null;
  //   }
  // }
  // onSelectPhoto(event) {
    
  //   if (event.target.files && event.target.files[0]) {
  //       const reader = new FileReader();
  //       reader.readAsDataURL(event.target.files[0]);

  //       reader.onload = (event: any) => { // called once readAsDataURL is completed
  //           const imageUrl = (event.target["result"]);
  //           this.compressImage(imageUrl,643,540 ).then((res:string) => {
  //            // console.log("imageUrl", res)
  //             if(res){
  //               this.uploadPhoto(res.split(',')[1]);

  //             }
  //           })
            
            
  //       };
  //   }
  // }

  private compressImage(src, newX, newY) {
    return new Promise((res, rej) => {
      const img = new Image();
      img.src = src;
      img.onload = () => {
        const elem = document.createElement('canvas');
        elem.width = newX;
        elem.height = newY;
        const ctx = elem.getContext('2d');
        ctx.drawImage(img, 0, 0, newX, newY);
        const data = ctx.canvas.toDataURL();
        res(data);
      }
      img.onerror = error => rej(error);
    })
  }

  private finishLoading() {
    this.photoLoading = false;
    this._loading.finishedLoading();
  }
  imageID:number;

 uploadPhoto(newPhoto: string) {
  this.photoLoading = true;
  this._loading.startLoading();
  switch (this.comingFrom) {
    case PhotoModelComingFrom.NewInspectionQuestionImages:
      this.question.Images.push(new ObservationPointQuestionImagesViewModel(newPhoto));
      this.onPhotoUpload.emit(newPhoto);
      this.toastr.success('Photo added to inspection');
      this.finishLoading();
      break;
    case PhotoModelComingFrom.InterpretationInspectionImages:
      this._inspectionService.uploadNewPhotoToImplementInspectionImages(this.implementInspection.ImplementInspectionId, newPhoto)
      .subscribe(r => {
        this.finishLoading();
        if (r.m_Item1) {
            this.toastr.success('Photo added to inspection');
            this.onPhotoUpload.emit(newPhoto);
        } else {
          this.toastr.error('Failed to upload photo');
        }
      });
      break;

    case PhotoModelComingFrom.NewInspectionInspectionImages:
      this.implementInspection.InspectionImages.push(new ImplementInspectionImageViewModel(newPhoto));
      this.onPhotoUpload.emit(newPhoto);
      this.finishLoading();
      break;
    case PhotoModelComingFrom.NewInspectionGeneralQuestionsImagesOnImplementLevel:
      this.inspectionGeneralQuestion.Image.push(new GeneralQuestionImageViewModel(newPhoto));
      this.onPhotoUpload.emit(newPhoto);
      this.finishLoading();
    break;
    case PhotoModelComingFrom.NewInspectionObservationPointImageOnComponentLevel:
      this.onPhotoUpload.emit(newPhoto);
      this.finishLoading();
      break;
    case PhotoModelComingFrom.InterpretationGeneralQuestionsImagesOnImplementLevel:
      this._inspectionService.uploadPhotoToGeneralQuestionImages(this.implementInspection , this.inspectionGeneralQuestion, newPhoto)
      .subscribe(r => {
        this.finishLoading();
        if (r.m_Item1) {
          this.toastr.success('Photo added to general questions');
          this.onPhotoUpload.emit(newPhoto);
        } else {
          this.toastr.error('Failed to upload photo');
        }
      });
      break;

      case PhotoModelComingFrom.InterpretationObservationPointImageOnComponentLevel:
        this._inspectionService.uploadNewPhotoToObservationPoint(this.observationPoint, newPhoto)
        .subscribe(r => {
          this.finishLoading();
          if (r.Id) {
            this.toastr.success('Photo added to observation point');
            this.onPhotoUpload.emit(r);
          } else {
            this.toastr.error('Failed to upload photo');
          }
        });
        break;

        case PhotoModelComingFrom.PreCheckListQuestionImages:
        this._inspectionService.uploadNewPhotoToPreChecklistAnswer(this.preChecklist, newPhoto)
        .subscribe(r => {
          this.finishLoading();
          if (r.m_Item1>0) {
            
            const photoData = new CheckListImagesVM();
            photoData.Id = r.m_Item1;
            photoData.Image = newPhoto;
           // this.toastr.success('Photo added to  point');
            this.onPhotoUpload.emit(photoData);
          } else {
            this.toastr.error('Failed to upload photo');
          }
        });
        break;

        case PhotoModelComingFrom.FECRAdditionalObs:
        this._inspectionService.UploadNewPhotoFECRAdditionObsPoint(this.FECRAdditionalObs, newPhoto)
        .subscribe(r => {
          this.finishLoading();
          if (r.m_Item1>0) {
            
            const photoData = new CheckListImagesVM();
            photoData.Id = r.m_Item1;
            photoData.Image = newPhoto;
           // this.toastr.success('Photo added to  point');
            this.onPhotoUpload.emit(photoData);
          } else {
            this.toastr.error('Failed to upload photo');
          }
        });
        break;
    default: break;

  }
 }
}





